
        <template>
          <div class="vc-snippet-doc">
            <h1>问题解答(problem-solving)</h1>
<ol>
<li>完美解决 <code>fatal: unable to access 'https://github.com/.../.git': Could not resolve host: github.com</code></li>
</ol>
<p>只需要在命令行中执行</p>
<pre class="hljs"><code>git config --<span class="hljs-variable language_">global</span> --unset http.<span class="hljs-property">proxy</span>

git config --<span class="hljs-variable language_">global</span> --unset https.<span class="hljs-property">proxy</span>
</code></pre>
<ol start="2">
<li>git错误：<code>OpenSSL SSL_connect: SSL_ERROR_SYSCALL in connection to github.com:443</code></li>
</ol>
<p>取消代理</p>
<pre class="hljs"><code>git config --<span class="hljs-variable language_">global</span> --unset http.<span class="hljs-property">proxy</span>
git config --<span class="hljs-variable language_">global</span> --unset https.<span class="hljs-property">proxy</span>
</code></pre>
<p>取消SSL校验</p>
<pre class="hljs"><code>env <span class="hljs-variable constant_">GIT_SSL_NO_VERIFY</span>=<span class="hljs-literal">true</span>
</code></pre>
<pre class="hljs"><code><span class="hljs-variable constant_">GET_SSL_NO_VERIFY</span>=<span class="hljs-literal">false</span>
</code></pre>
<pre class="hljs"><code>git config --<span class="hljs-variable language_">global</span> --unset http.<span class="hljs-property">proxy</span>
git config --<span class="hljs-variable language_">global</span> http.<span class="hljs-property">sslVerify</span> <span class="hljs-literal">false</span>
</code></pre>
<p>zsh: permission denied问题的解决办法</p>
<ol>
<li>问题原因:</li>
</ol>
<pre class="hljs"><code>用户没有权限，所以才出现了这个错误，所以只需要用chmod修改一下权限就可以了
</code></pre>
<ol start="2">
<li>解决方法</li>
</ol>
<pre class="hljs"><code>chmod u+x *.<span class="hljs-property">sh</span>
</code></pre>
<ol start="3">
<li>说明</li>
</ol>
<pre class="hljs"><code>chmod是权限管理命令change the permissions mode <span class="hljs-keyword">of</span> a file的缩写。
u代表所有者。x代表执行权限。’+’ 表示增加权限。
chmod u+x file.<span class="hljs-property">sh</span> 就表示对当前目录下的file.<span class="hljs-property">sh</span>文件的所有者增加可执行权限。
</code></pre>

          </div>
        </template>
        <script>
           
           export default {
           name: 'vc-component-doc',
           components: {
            
           },
           data(){
            return {}
           }
         }
       </script>
       <style lang='scss'>
         
       </style>